import React from 'react';
import { ContextMenuItemType } from '@marageti/z4-lib';
import { Ticket } from '@marageti/z4-sdk/lib/tickets';
import ContextMenuComplete from '../list-cards/context-menu';

type TicketContextMenuProps = {
  ticket: Ticket;
  onEdit: () => void;
  onReassign: () => void;
  onDelete: () => void;
};

const TicketContextMenu = ({
  ticket,
  onEdit,
  onReassign,
  onDelete,
}: TicketContextMenuProps) => {
  const items: ContextMenuItemType[] = [
    { label: 'Edit', action: onEdit, disabled: ticket.status === 'COMPLETED' },
    { label: 'Reassign', action: onReassign },
    { label: 'Delete', action: onDelete },
  ];
  return (
    <ContextMenuComplete
      id={`ticket-${ticket.id}`}
      items={items}
    />
  );
};

export default TicketContextMenu;
